// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vhx4","left":"styles_left__2qf_9","desktopActions":"styles_desktopActions__jWSml","title":"styles_title__I1QzY"};